import { AccountBalancesStatsParam } from '@tassat/fred-extended-definitions';

import { CreatePledge } from './createPledge';
import { ICreatePledgeFormValues } from '../createPledge/createPledgeForm/types';

export interface ICreatePledgeProps {
    title: string;
    transactionValues: ICreatePledgeFormValues;
    setTransactionValues: (values?) => void;
    handleCreatePledge: (pledgeValues) => void;
    goBack: (event?) => void;
    accountPositionBalance: AccountBalancesStatsParam;
}

export default CreatePledge;